/**
 * Join two URL paths together with a forward slash between them.
 */

// Use a single strictly-typed overload and a loosely-typed implementation
// because Typescript cannot type-check the implementation.
export function joinPaths(a, b) {
  if (a === '') return b;
  if (b === '') return a;
  return `${a.replace(/\/$/u, '')}/${b.replace(/^\//u, '')}`;
}